/* eslint-disable semi */
import {
  LOADING,
  RESULT,
  LIST,
  INIT_CREATE,
  CREATE,
  READ,
  UPDATE,
  DELETE,
  STOCK_UPDATE,
  LIST_VM,
  LIST_BALANCE,
  TOGGLE_REFUND,
  MANUAL_UPDATE,
  CONFIG_DOWNLOAD,
  POST_CONFIG_DOWNLOAD,
  ADD_PROJECT_HANDLE,
  TOGGLER_MULTI_BALANCE
} from "./actionTypes";

export const loading = actionType => ({
  type: LOADING,
  payload: { actionType },
});

export const result = (actionType, result) => ({
  type: RESULT,
  payload: { actionType, result },
});

export const list = () => ({
  type: LIST,
});
export const list_balance = () => ({
  type: LIST_BALANCE,
});
export const list_vm = () => ({
  type: LIST_VM,
});

export const initCreate = () => ({
    type: INIT_CREATE,
  });

export const create = payload => ({
  type: CREATE,
  payload,
});

export const addProjectHandle = payload => ({
  type: ADD_PROJECT_HANDLE,
  payload,
});
export const manualUpdate = payload => ({
  type: MANUAL_UPDATE,
  payload,
});
export const toggleRefund = payload => ({
  type: TOGGLE_REFUND,
  payload,
});
export const toggleMultiBalance = payload => ({
  type: TOGGLER_MULTI_BALANCE,
  payload,
});

export const read = sku => ({
  type: READ,
  payload: { sku },
});

export const getDownloadConfig = payload => ({
  type: CONFIG_DOWNLOAD,
  payload,
});
export const setDownloadConfig = payload => ({
  type: POST_CONFIG_DOWNLOAD,
  payload,
});

export const update = payload => ({
  type: UPDATE,
  payload,
});

export const stockUpdate = payload => ({
  type: STOCK_UPDATE,
  payload,
});

export const delete_ = payload => ({
  type: DELETE,
  payload,
});
